module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_9016.9570072d.png";